module.exports = __webpack_public_path__ + "static/media/Submarine_end.41566825.mp4";